// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1iy_o","resendInfoText":"OnGoingPaymentBox_resendInfoText__22bdA"};